import EAFieldset from "../../EAFieldset";
import ErweiterteSuche from "../ErweiterteSuche";
import EAButtonBar from "../../EAButtonBar";
import EAButton from "../../EAButton";
import React, {useEffect, useState} from "react";
import {useHttp} from "../../../services/HttpService";
import {getMessstellentypEndpoint} from "../../../services/WertelistenService";
import {getAbwasserbeseitigungspflichtigeEndpoint} from "../../../services/OrganisationsService";
import {statusOptionen} from "../../../consts/valueLists";
import {personalisierungEndpoint} from "../../../services/AnwenderService";

export default function MessstelleArbeitsListeSuche({
                                                        id,
                                                        formFactory,
                                                        attr,
                                                        sharedFilter,
                                                        onErweiterteSucheOpenChanged,
                                                        sharedFormFactory,
                                                        regionalstelleOptionen,
                                                        raeumlichesKriteriumOptionen,
                                                        behoerdeOptionen,
                                                        storedFilter,
                                                        setStoredFilter,
                                                        setFilter,
                                                        resetSharedFilter,
                                                        filter,
                                                        setSelected,
                                                        executeSearch,
                                                        initialSearchParameters
                                                    }) {
    const filterFieldId = "messstellebezeichnung-filter";

    const [abwasserbeseitigungspflichtigeOptionen] = useHttp(getAbwasserbeseitigungspflichtigeEndpoint);
    const [messstellentypOptionen] = useHttp(getMessstellentypEndpoint);

    const [personalisierungsfilter, refetchPersonalisierungsfilter] = useHttp(personalisierungEndpoint);
    const [messstellentypPersonalisiert, setMessstellentypPersonalisiert] = useState(false);
    const [raeumlichesKriteriumPersonalisiert, setRaeumlichesKriteriumPersonalisiert] = useState(false);

    useEffect(() => {
        let newMessstellentypValue = false;
        let newVerwaltungseinheitValue = false;
        if (personalisierungsfilter.data) {
            if (personalisierungsfilter.data.messstellentyp && sharedFilter.personalisiert) {
                newMessstellentypValue = true;
            }
            if (personalisierungsfilter.data.verwaltungseinheit && sharedFilter.personalisiert) {
                newVerwaltungseinheitValue = true;
            }
        }

        setMessstellentypPersonalisiert(newMessstellentypValue);
        setRaeumlichesKriteriumPersonalisiert(newVerwaltungseinheitValue);
    }, [personalisierungsfilter, sharedFilter.personalisiert]);

    useEffect(() => {
        refetchPersonalisierungsfilter().then();
    }, [sharedFilter.personalisiert, refetchPersonalisierungsfilter]);


    return (
        <EAFieldset id={id} caption="Suche">
            <div className="simpleFilter gridl">
                {formFactory.renderInput(attr.messstellenNr, filterFieldId + "-" + attr.messstellenNr, "Messstellen-Nr.")}
                {formFactory.renderInput(attr.bezeichnung, filterFieldId + "-" + attr.bezeichnung, "Messstellenbezeichnung")}
                {formFactory.renderInput(
                    attr.anlagenBezeichnung,
                    filterFieldId + "-" + attr.anlagenBezeichnung,
                    "Abwasseranlagenbezeichnung"
                )}
                {formFactory.renderAutocompletePersonalisiert(
                    attr.messstellentyp,
                    filterFieldId + "-" + attr.messstellentyp,
                    "Messstellentyp",
                    messstellentypOptionen.data,
                    "value",
                    "id",
                    messstellentypOptionen.loading,
                    false,
                    false,
                    null,
                    null,
                    messstellentypPersonalisiert
                )}
                {formFactory.renderAutocomplete(
                    attr.messstellenstatus,
                    filterFieldId + "-" + attr.messstellenstatus,
                    "Messstellenstatus",
                    statusOptionen,
                    "value",
                    "id",
                    false
                )}
            </div>
            <ErweiterteSuche
                sharedFilter={sharedFilter}
                onExtendedSearchOpenChanged={onErweiterteSucheOpenChanged}
                sharedFormFactory={sharedFormFactory}
                regionalstelleOptionen={regionalstelleOptionen}
                raeumlichesKriteriumOptionen={raeumlichesKriteriumOptionen}
                behoerdeOptionen={behoerdeOptionen}
                additionalPrefixFields={[
                    formFactory.renderAutocomplete(
                        attr.abwasserbeseitigungspflichtiger,
                        filterFieldId + "-" + attr.abwasserbeseitigungspflichtiger,
                        "Abwasserbeseitigungspflichtiger",
                        abwasserbeseitigungspflichtigeOptionen.data,
                        "bezeichnung",
                        "id",
                        abwasserbeseitigungspflichtigeOptionen.loading
                    ),
                ]}
                raeumlichesKriteriumPersonalisiert={raeumlichesKriteriumPersonalisiert}
            />
            <EAButtonBar style={{marginTop: "var(--buttonBar-spacing-top)"}}>
                <EAButton
                    id={filterFieldId + "-reset"}
                    label="Zurücksetzen"
                    onClick={() => {
                        setStoredFilter(initialSearchParameters);
                        setFilter(initialSearchParameters);
                        executeSearch(initialSearchParameters, sharedFilter);
                    }}
                />
                <EAButton id={filterFieldId + "-submit"} label="Suchen"
                          onClick={() => {
                              let newStoredFilter = {...filter, pageInfo: {...storedFilter.pageInfo, page: 0}};
                              setStoredFilter(newStoredFilter);
                              setSelected([]);
                              executeSearch(newStoredFilter, sharedFilter);
                          }}
                          color="primary"/>
            </EAButtonBar>
        </EAFieldset>
    );
}
